import React from 'react'
import { Dropdown } from 'react-bootstrap'
import { useLocation, useNavigate } from 'react-router-dom'
import { logout } from './Sidebar'

// Layout follows rock-dashboard src/components/layout/Topbar.js.
const sectionTitles = [
    ['/portal/dashboard', 'Dashboard'],
    ['/portal/user', 'Users'],
    ['/portal/create-user', 'Users'],
    ['/portal/fairy-ai', 'Fairy Ai'],
    ['/portal/create-fairy-ai', 'Fairy Ai'],
    ['/portal/face-dance', 'Face Dance'],
    ['/portal/create-face-dance', 'Face Dance'],
    ['/portal/face-swap', 'Face Swap'],
    ['/portal/create-face-swap', 'Face Swap'],
    ['/portal/category', 'Category'],
    ['/portal/create-category', 'Category'],
    ['/portal/config', 'Config'],
    ['/portal/create-config', 'Config'],
    ['/portal/monetization-global', 'Monetization Global'],
    ['/portal/update-monetization-global', 'Monetization Global'],
    ['/portal/monetization', 'Monetization List'],
    ['/portal/create-monetization', 'Monetization List'],
    ['/portal/service-key', 'Service Key'],
    ['/portal/create-service-key', 'Service Key'],
    ['/portal/domains', 'Domains']
];

const titleFromPath = (pathname) =>
    sectionTitles.find(([prefix]) => pathname.startsWith(prefix))?.[1] ?? 'Appixi Admin';

function Topbar() {
    const location = useLocation();
    const navigate = useNavigate();

    return (
        <header className="navbar navbar-expand-md d-none d-lg-flex d-print-none">
            <div className="container-fluid">
                <div className="navbar-nav flex-row align-items-center">
                    <div className="fw-bold">{titleFromPath(location.pathname)}</div>
                </div>

                <div className="navbar-nav flex-row order-md-last align-items-center gap-2">
                    <Dropdown align="end">
                        <Dropdown.Toggle
                            variant="link"
                            className="songsnap-icon-button text-decoration-none d-flex align-items-center gap-2"
                        >
                            <span
                                className="avatar avatar-sm rounded-circle"
                                style={{ background: 'var(--accent-bg-active)', color: 'var(--accent-fg)' }}
                                aria-hidden="true"
                            >
                                A
                            </span>
                            <span className="d-none d-xl-inline text-muted fw-semibold">Admin</span>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item onClick={() => logout(navigate)}>Logout</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            </div>
        </header>
    )
}

export default Topbar
